import { useQuery } from '@tanstack/react-query'
import { fetchPositions } from '../services/care_plan';

const GetPositions = () => {
 const getPositions = useQuery({
    queryKey:['positions'],
    queryFn: fetchPositions
 })
 return getPositions;
}

export default GetPositions